/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, TextField } from "@mui/material";
import LabelledField from "components/labelled-field";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import { ComponentImageListItemContext } from "./component-image-list-context";
import { ListImage } from "./list-image";
import { ImageListLink } from "./image-list-link";

const ImageListItemEditor = () => {
    
    const { t } = useTranslation();
    const {
        index,
        position,
        item,
        updateItemByPosition
    } = useContext(ComponentImageListItemContext) || {};
    
    const {
        image: _image,
        link: _link,
        heading: _heading,
        description: _description
    } = item || {};
    
    const [image,setImage] = useState(_image); // guid
    const [link,setLink] = useState(_link);
    const [heading,setHeading] = useState(_heading);
    const [description,setDescription] = useState(_description);
    
    const updateImage = (guid) => {
        setImage(guid);
        // const nextItem = structuredClone({ ...item, image: guid })
        // updateItemByPosition(nextItem, position)
    };
     
    const onChangeHeading = (event) => {
        const newHeading = event.target.value;
        setHeading(newHeading);
        // const nextItem = structuredClone({ ...item, heading: newHeading })
        // updateItemByPosition(nextItem, position)
    };
    
    const updateLink = async (newLink) => {
        setLink(newLink);
        // const nextItem = structuredClone({ ...item, link: newLink })
        // updateItemByPosition(nextItem, position)
    };
    
    const onChangeDescription = (newDesc) => {
        setDescription(newDesc);
    };
    useEffect(
        () => {
            const nextItem = structuredClone({
                ...item,
                image,
                heading,
                description,
                link,
            });
            updateItemByPosition(nextItem, position);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [description,link,heading,image]
    );
    
    return (
        <div className='simplicity-image-list-item' style={{ width: "100%" }}>
            <Stack direction='row' justifyContent='flex-start'>
                <div className='simplicity-image-list-item-image'></div>
                <div className='simplicity-image-list-item-data' style={{ width: "100%" }}>
                    <div style={{ width: "100%" }}>
                        <ListImage
                            index={index}
                            image={image}
                            updateImage={updateImage}
                        />
                    </div><Box>
                        <LabelledField label={`${t("commons.heading")}: `}>
                            <TextField
                                onChange={onChangeHeading}
                                id='heading'
                                defaultValue={heading}
                                fullWidth={true}
                            />
                        </LabelledField>
                    </Box>
                    <Box>
                        <LabelledField label={`${t("commons.description")} :`}>
                            <SimplicityComposerEnsureTipTap
                                richtext={description}
                                onChange={onChangeDescription}
                            />
                        </LabelledField>
                    </Box>
                    <Box>
                        <LabelledField label={`${t("commons.link")}: `}>
                            <ImageListLink
                                index={index}
                                link={link}
                                updateLink={updateLink}
                            />
                        </LabelledField>
                    </Box>
                </div>
            </Stack>
        </div>
    );
};
ImageListItemEditor.displayName = "ImageListItemEditor";
export { ImageListItemEditor };
